import React, { useRef, useState } from 'react';

const UserExchangedTicketsFilter = props => {
  let formRefrence = useRef();
  let [cafeNamePart, setCafeName] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeName('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex justidy-content-between px-1">
            <input
              onChange={event => setCafeName(event.target.value)}
              value={cafeNamePart || ''}
              name="cafeNamePart"
              type="text"
              className="form-control mx-1 col-3 h-50 py-2"
              placeholder={locales('fields.cafe.name')}
            />
            <div className="d-flex justify-content-end p-0">
              <input
                name="resetButton"
                type="reset"
                value={locales('fields.reset')}
                className="btn btn-danger w-5 mx-2"
              />
              <button type="submit" id="apply-filter-btn-factor" className="btn btn-success w-5 mx-2">
                {locales('fields.applyFilters')}
              </button>
            </div>
          </div>
        </main>
      </form>
    </article>
  );
};

export default UserExchangedTicketsFilter;
